import './header.css';

function LargeHeader(props) {
    const withBorder = props.withBorder ? "with-border" : "";
    const className = props.class ? props.class : "";
    
    return (
        <h1 id={props.id} className={`header large ${withBorder} ${className}`}>
            { props.children }
        </h1>
    );
}

function MediumHeader(props) {
    const withBorder = props.withBorder ? "with-border" : "";
    const className = props.class ? props.class : "";
    
    return (
        <h2 id={props.id} className={`header medium ${withBorder} ${className}`}>
            { props.children }
        </h2>
    );
}

function SmallHeader(props) {
    const withBorder = props.withBorder ? "with-border" : "";
    const className = props.class ? props.class : "";
    
    return (
        <h3 id={props.id} className={`header small ${withBorder} ${className}`}>
            { props.children }
        </h3>
    );
}

export function Header(props) {
    if (props.size === "large") {
        return <LargeHeader {...props} />;
    }

    if (props.size === "medium") {
        return <MediumHeader {...props} />;
    }

    if (props.size === "small") {
        return <SmallHeader {...props} />;
    }

    return <LargeHeader {...props} />;
}